export default __webpack_public_path__ + "static/media/traditional_row_end.f5df40b5.svg";